import salatkaDnia from 'assets/images/salatka_dnia.png';
import danieDnia from 'assets/images/danie_dnia.png';
import zupaDnia from 'assets/images/zupa_dnia.png';

const obrazkiBadge = { zupaDnia, danieDnia, salatkaDnia };
export default obrazkiBadge;
